import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=0c178116&"
import script from "./Album.vue?vue&type=script&lang=js&"
export * from "./Album.vue?vue&type=script&lang=js&"
import style0 from "./Album.vue?vue&type=style&index=0&id=0c178116&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports